import { Observable } from 'rxjs/Observable';
import {ValueListener} from "./interfaces";
import {Questions} from "../rsvpQuestions/v2"
import Question from "../rsvpQuestions/v2/Question";
export const observeRSVPQuestionsV2 = (eventDataSource: any, listener: ValueListener<Questions>) => {

    //listener = eventDataSource.wrapListener(listener);

    const inputs = {
        ownerNameValue: undefined,
        fianceeNameValue: undefined,
        rsvp: undefined
    };

    var questions = null;
    const compute = function (inputs) {
        if (!questions) {
            questions = new Questions(eventDataSource, inputs.rsvp);
        }
        else {
            questions.updateRsvpData(inputs.rsvp);
        }
        return questions;
    };

    const onUpdate = function () {
        if (Object.keys(inputs).filter(x => (typeof inputs[x] == "undefined")).length > 0) {
            return;
        }

        listener.onValue(compute(inputs));
    };


    var receiver = function (k, value) {
        inputs[k] = value;
        onUpdate();
    };

    Object.keys(inputs).forEach(k => {
        var observeFunction = `observe${k.charAt(0).toUpperCase()}${k.slice(1)}`;
        eventDataSource[observeFunction]({onValue: receiver.bind(null, k), onError: receiver.bind(null, k, null)});
    });
};

export const observeRSVPQuestions = (ds: any): Observable<Question[]> => {
    let questions: Questions | null = null;
    return ds.observeRsvp$().map(rsvpData => {
        if (!questions) {
            questions = new Questions(ds, rsvpData);
        }
        else {
            questions.updateRsvpData(rsvpData);
        }

        return questions.asSortedArray().filter(q => q.isEnabled);
    });
}
